import type { Route, RouteConfig } from 'vue-router'
import { allRoles, isAuthorized, lazyLoadView } from '@/router/routing'

export const ndsRoutes: RouteConfig[] = [
  {
    path: 'ui-nds-button',
    name: 'ui-nds-button',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsButtonView.vue')),
    meta: {
      title: 'NdsButton',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-button',
    },
  },
  {
    path: 'ui-nds-table',
    name: 'ui-nds-table',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsTableView.vue')),
    meta: {
      title: 'NdsTable',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-table',
    },
  },
  {
    path: 'ui-nds-icon',
    name: 'ui-nds-icon',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsIconView.vue')),
    meta: {
      title: 'NdsIcon',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-icon',
    },
  },
  {
    path: 'ui-nds-modal',
    name: 'ui-nds-modal',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsModalView.vue')),
    meta: {
      title: 'NdsModal',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-modal',
    },
  },
  {
    path: 'ui-nds-spinner',
    name: 'ui-nds-spinner',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsSpinnerView.vue')),
    meta: {
      title: 'NdsSpinner',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-spinner',
    },
  },
  {
    path: 'ui-nds-input-radio',
    name: 'ui-nds-input-radio',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsInputRadioView.vue')),
    meta: {
      title: 'NdsInputRadio',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-input-radio',
    },
  },
  {
    path: 'ui-nds-drop-down',
    name: 'ui-nds-drop-down',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsDropDownView.vue')),
    meta: {
      title: 'NdsDropdown',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-drop-down',
    },
  },
  {
    path: 'ui-nds-input',
    name: 'ui-nds-input',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsInputView.vue')),
    meta: {
      title: 'NdsInput',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-input',
    },
  },
  {
    path: 'ui-nds-input-label',
    name: 'ui-nds-input-label',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsInputLabelView.vue')),
    meta: {
      title: 'NdsInputLabel',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-input-label',
    },
  },
  {
    path: 'ui-nds-date-picker',
    name: 'ui-nds-date-picker',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsDatePickerView.vue')),
    meta: {
      title: 'NdsDatePicker',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-date-picker',
    },
  },
  {
    path: 'ui-nds-pagination',
    name: 'ui-nds-pagination',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsPaginationView.vue')),
    meta: {
      title: 'NdsPagination',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-pagination',
    },
  },
  {
    path: 'ui-nds-load-more',
    name: 'ui-nds-load-more',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsLoadMoreView.vue')),
    meta: {
      title: 'NdsLoadMore',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-load-more',
    },
  },
  {
    path: 'ui-nds-reset-button',
    name: 'ui-nds-reset-button',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsResetButtonView.vue')),
    meta: {
      title: 'NdsResetButton',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-reset-button',
    },
  },
  {
    path: 'ui-nds-card',
    name: 'ui-nds-card',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsCardView.vue')),
    meta: {
      title: 'NdsCard',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-card',
    },
  },
  {
    path: 'ui-nds-progress-bar',
    name: 'ui-nds-progress-bar',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsProgressBarView.vue')),
    meta: {
      title: 'NdsProgressBar',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-progress-bar',
    },
  },
  {
    path: 'ui-nds-stepper',
    name: 'ui-nds-stepper',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsStepperView.vue')),
    meta: {
      title: 'NdsStepper',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-stepper',
    },
  },
  {
    path: 'ui-nds-input-checkbox',
    name: 'ui-nds-input-checkbox',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsInputCheckboxView.vue')),
    meta: {
      title: 'NdsInputCheckbox',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-input-checkbox',
    },
  },
  {
    path: 'ui-nds-textarea',
    name: 'ui-nds-textarea',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsTextareaView.vue')),
    meta: {
      title: 'NdsTextarea',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-textarea',
    },
  },
  {
    path: 'ui-nds-answer-button',
    name: 'ui-nds-answer-button',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsAnswerButtonView.vue')),
    meta: {
      title: 'NdsAnswerButton',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-answer-button',
    },
  },
  {
    path: 'ui-nds-tree-view',
    name: 'ui-nds-tree-view',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsTreeView.vue')),
    meta: {
      title: 'NdsTreeView',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-tree-view',
    },
  },
  {
    path: 'ui-nds-alert',
    name: 'ui-nds-alert',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsAlertView.vue')),
    meta: {
      title: 'NdsAlert',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-alert',
    },
  },
  {
    path: 'ui-nds-comment',
    name: 'ui-nds-comment',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsCommentView.vue')),
    meta: {
      title: 'NdsComment',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-comment',
    },
  },
  {
    path: 'ui-nds-score-badge',
    name: 'ui-nds-score-badge',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsScoreBadgeView.vue')),
    meta: {
      title: 'NdsScoreBadge',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-score-badge',
    },
  },
  {
    path: 'ui-nds-score-answer-badge',
    name: 'ui-nds-score-answer-badge',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsScoreAnswerBadgeView.vue')),
    meta: {
      title: 'NdsScoreAnswerBadge',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-score-answer-badge',
    },
  },
  {
    path: 'ui-nds-score',
    name: 'ui-nds-score',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsScoreView.vue')),
    meta: {
      title: 'NdsScore',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-score',
    },
  },
  {
    path: 'ui-nds-score-range',
    name: 'ui-nds-score-range',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsScoreRangeView.vue')),
    meta: {
      title: 'NdsScoreRange',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-score-range',
    },
  },
  {
    path: 'ui-nds-score-info',
    name: 'ui-nds-score-info',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsScoreInfoView.vue')),
    meta: {
      title: 'NdsScoreInfo',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-score-info',
    },
  },
  {
    path: 'ui-nds-tooltip',
    name: 'ui-nds-tooltip',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsTooltipView.vue')),
    meta: {
      title: 'NdsTooltip',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-tooltip',
    },
  },
  {
    path: 'ui-nds-option',
    name: 'ui-nds-option',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsOptionView.vue')),
    meta: {
      title: 'NdsOption',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-option',
    },
  },
  {
    path: 'ui-nds-upload-file',
    name: 'ui-nds-upload-file',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsUploadFileView.vue')),
    meta: {
      title: 'NdsUploadFile',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-upload-file',
    },
  },
  {
    path: 'ui-nds-panel',
    name: 'ui-nds-panel',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsPanelView.vue')),
    meta: {
      title: 'NdsPanel',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-panel',
    },
  },
  {
    path: 'ui-nds-tag',
    name: 'ui-nds-tag',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsTagView.vue')),
    meta: {
      title: 'NdsTag',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-tag',
    },
  },
  {
    path: 'ui-nds-form-input',
    name: 'ui-nds-form-input',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsFormInputView.vue')),
    meta: {
      title: 'NdsFormInput',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-form-input',
    },
  },
  {
    path: 'ui-nds-markdown-editor',
    name: 'ui-nds-markdown-editor',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsMarkdownEditorView.vue')),
    meta: {
      title: 'NdsMarkdownEditor',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-markdown-editor',
    },
  },
  {
    path: 'ui-nds-markdown-viewer',
    name: 'ui-nds-markdown-viewer',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsMarkdownViewerView.vue')),
    meta: {
      title: 'NdsMarkdownViewer',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-markdown-viewer',
    },
  },
  {
    path: 'ui-nds-chip',
    name: 'ui-nds-chip',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsChipView.vue')),
    meta: {
      title: 'NdsChip',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-chip',
    },
  },
  {
    path: 'ui-nds-chip-selector',
    name: 'ui-nds-chip-selector',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsChipSelectorView.vue')),
    meta: {
      title: 'NdsChipSelector',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-chip-selector',
    },
  },
  {
    path: 'ui-nds-tab',
    name: 'ui-nds-tab',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsTabView.vue')),
    meta: {
      title: 'NdsTab',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-tab',
    },
  },
  {
    path: 'ui-nds-tab-bar',
    name: 'ui-nds-tab-bar',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsTabBarView.vue')),
    meta: {
      title: 'NdsTabBar',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-tab-bar',
    },
  },
  {
    path: 'ui-nds-input-select',
    name: 'ui-nds-input-select',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsInputSelectView.vue')),
    meta: {
      title: 'NdsInputSelect',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-input-select',
    },
  },
  {
    path: 'ui-nds-input-multi-select',
    name: 'ui-nds-input-multi-select',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsInputMultiSelectView.vue')),
    meta: {
      title: 'NdsInputMultiSelect',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-input-multi-select',
    },
  },
  {
    path: 'ui-nds-heading',
    name: 'ui-nds-heading',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsHeadingView.vue')),
    meta: {
      title: 'NdsHeading',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-heading',
    },
  },
  {
    path: 'ui-nds-text',
    name: 'ui-nds-text',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsTextView.vue')),
    meta: {
      title: 'NdsText',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-text',
    },
  },
  {
    path: 'ui-nds-line-clamp',
    name: 'ui-nds-line-clamp',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsLineClampView.vue')),
    meta: {
      title: 'NdsLineClamp',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-line-clamp',
    },
  },
  {
    path: 'ui-nds-octagon-alert',
    name: 'ui-nds-octagon-alert',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsOctagonAlertView.vue')),
    meta: {
      title: 'NdsOctagonAlert',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-octagon-alert',
    },
  },
  {
    path: 'ui-nds-empty-state-message',
    name: 'ui-nds-empty-state-message',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsEmptyStateMessageView.vue')),
    meta: {
      title: 'NdsEmptyStateMessage',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-empty-state-message',
    },
  },
  {
    path: 'ui-nds-segmented-buttons',
    name: 'ui-nds-segmented-buttons',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsSegmentedButtonsView.vue')),
    meta: {
      title: 'NdsSegmentedButtons',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-segmented-buttons',
    },
  },
  {
    path: 'ui-nds-collection',
    name: 'ui-nds-collection',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsCollectionView.vue')),
    meta: {
      title: 'NdsCollection',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-collection',
    },
  },
  {
    path: 'ui-nds-paragraph',
    name: 'ui-nds-paragraph',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsParagraphView.vue')),
    meta: {
      title: 'NdsParagraph',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-paragraph',
    },
  },
  {
    path: 'ui-nds-tag-area',
    name: 'ui-nds-tag-area',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsTagAreaView.vue')),
    meta: {
      title: 'NdsTagArea',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-tag-area',
    },
  },
  {
    path: 'ui-nds-tag-overflow',
    name: 'ui-nds-tag-overflow',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsTagOverflowView.vue')),
    meta: {
      title: 'NdsTagOverflow',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-tag-overflow',
    },
  },
  {
    path: 'ui-nds-badge',
    name: 'ui-nds-badge',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsBadgeView.vue')),
    meta: {
      title: 'NdsBadge',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-badge',
    },
  },
  {
    path: 'ui-nds-popover',
    name: 'ui-nds-popover',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsPopoverView.vue')),
    meta: {
      title: 'NdsPopover',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-popover',
    },
  },
  {
    path: 'ui-nds-menu-item',
    name: 'ui-nds-menu-item',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsMenuItemView.vue')),
    meta: {
      title: 'NdsMenuItem',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-menu-item',
    },
  },
  {
    path: 'ui-nds-filter-select',
    name: 'ui-nds-filter-select',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsFilterSelectView.vue')),
    meta: {
      title: 'NdsFilterSelect',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-filter-select',
    },
  },
  {
    path: 'ui-nds-input-range',
    name: 'ui-nds-input-range',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsInputRangeView.vue')),
    meta: {
      title: 'NdsInputRange',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-input-range',
    },
  },
  {
    path: 'ui-nds-message-card',
    name: 'ui-nds-message-card',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsMessageCardView.vue')),
    meta: {
      title: 'NdsMessageCard',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-message-card',
    },
  },
  {
    path: 'ui-nds-chart-line',
    name: 'ui-nds-chart-line',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsChartLineView.vue')),
    meta: {
      title: 'NdsChartLine',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-chart-line',
    },
  },
  {
    path: 'ui-nds-chart-bar',
    name: 'ui-nds-chart-bar',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsChartBarView.vue')),
    meta: {
      title: 'NdsChartBar',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-chart-bar',
    },
  },
  {
    path: 'ui-nds-chart-doughnut',
    name: 'ui-nds-chart-doughnut',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsChartDoughnutView.vue')),
    meta: {
      title: 'NdsChartDoughnut',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-chart-doughnut',
    },
  },
  {
    path: 'ui-nds-chart-radar',
    name: 'ui-nds-chart-radar',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsChartRadarView.vue')),
    meta: {
      title: 'NdsChartRadar',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-chart-radar',
    },
  },
  {
    path: 'ui-nds-chart-gauge',
    name: 'ui-nds-chart-gauge',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsChartGaugeView.vue')),
    meta: {
      title: 'NdsChartGauge',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-chart-gauge',
    },
  },
  {
    path: 'ui-nds-datatable-wrapper',
    name: 'ui-nds-datatable-wrapper',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsDatatableWrapperView.vue')),
    meta: {
      title: 'NdsDatatableWrapper',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-datatable-wrapper',
    },
  },
  {
    path: 'ui-nds-datatable',
    name: 'ui-nds-datatable',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsDatatableView.vue')),
    meta: {
      title: 'NdsDatatable',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-datatable',
    },
  },
  {
    path: 'ui-nds-datatable-group-by',
    name: 'ui-nds-datatable-group-by',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsDatatableGroupByView.vue')),
    meta: {
      title: 'NdsDatatableGroupBy',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-datatable-group-by',
    },
  },
  {
    path: 'ui-nds-container',
    name: 'ui-nds-container',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsContainerView.vue')),
    meta: {
      title: 'NdsContainer',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-container',
    },
  },
  {
    path: 'ui-nds-text-ellipsis',
    name: 'ui-nds-text-ellipsis',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsTextEllipsisView.vue')),
    meta: {
      title: 'NdsTextEllipsis',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-text-ellipsis',
    },
  },
  {
    path: 'ui-nds-textarea-suggestions',
    name: 'ui-nds-textarea-suggestions',
    component: () => lazyLoadView(import('@/ui-kit/views/nds/UiKitNdsTextareaSuggestionsView.vue')),
    meta: {
      title: 'NdsTextareaSuggestions',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-textarea-suggestions',
    },
  },
]
